// @ts-nocheck

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "../../components/common/softBox";
import SoftTypography from "../../components/common/softTypography";

// Soft UI Dashboard React examples
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import Footer from "../../components/footer";
import MiniStatisticsCard from "../../components/cards/statisticsCards/miniStatisticsCard";
// import ReportsBarChart from "../../components/charts/barCharts/reportsBarChart";
// import GradientLineChart from "../../components/charts/lineCharts/gradientLineChart";

// Soft UI Dashboard React base styles
import typography from "../../assets/theme/base/typography";

// Dashboard layout components
import BuildByDevelopers from "./components/buildByDevelopers";
import WorkWithTheRockets from "./components/workWithTheRockets";
import Projects from "./components/projects";
import OrderOverview from "./components/orderOverview";
// import paidIcon from '../../assets/images/paid.png';
// import publicIcon from '../../assets/images/public.png';
// import trophyIcon from '../../assets/images/trophy.png';
// import cartIcon from '../../assets/images/cart.png';


import PaidIcon from '@mui/icons-material/Paid';
import PeopleIcon from '@mui/icons-material/People';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// Data
import reportsBarChartData from "./data/reportsBarChartData";
import gradientLineChartData from "./data/gradientLineChartData";

function Dashboard() {
  const { size } = typography;
  const { chart, items } = reportsBarChartData;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Room" }}
                count="$53,000"
                // percentage={{ color: "success", text: "+55%" }}
                icon={{ color: "final", component:<PaidIcon  /> }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Total Contact inquiry" }}
                count="2,300"
                percentage={{ color: "success",  }}
                icon={{ color: "final", component:<PeopleIcon /> }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "new Contact inquiry" }}
                count="+3,462"
                percentage={{ color: "error", }}
                icon={{ color: "final", component:<EmojiEventsIcon /> }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "total article" }}
                count="$103,430"
                percentage={{ color: "success",  }}
                icon={{
                  color: "final",
                  component: <ShoppingCartIcon />
                }}
              />
            </Grid>
          </Grid>
        </SoftBox>
        {/* <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={7}>
              <BuildByDevelopers />
            </Grid>
            <Grid item xs={12} lg={5}>
              <WorkWithTheRockets />
            </Grid>
          </Grid>
        </SoftBox> */}
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={5}>
              {/* <ReportsBarChart
                title="active users"
                description={
                  <>
                    (<strong>+23%</strong>) than last week
                  </>
                }
                chart={chart}
                items={items}
              /> */}
            </Grid>
            <Grid item xs={12} lg={7}>
              {/* <GradientLineChart
                title="Sales Overview"
                description={
                  <SoftBox display="flex" alignItems="center">
                    <SoftBox fontSize={size.lg} color="success" mb={0.3} mr={0.5} lineHeight={0}>
                      <Icon className="font-bold">arrow_upward</Icon>
                    </SoftBox>
                    <SoftTypography variant="button" color="text" fontWeight="medium">
                      4% more{" "}
                      <SoftTypography variant="button" color="text" fontWeight="regular">
                        in 2021
                      </SoftTypography>
                    </SoftTypography>
                  </SoftBox>
                }
                height="20.25rem"
                chart={gradientLineChartData}
              /> */}
            </Grid>
          </Grid>
        </SoftBox>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={8}>
            {/* <Projects /> */}
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            {/* <OrderOverview /> */}
          </Grid>
        </Grid>
      </SoftBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Dashboard;
